import React from "react";

// Mesma marcação que o FontAwesomeIcon gerava, sem carregar a biblioteca.
const Icone = ({ icon, className = "" }) => {
  const [largura, altura, caminho] = icon;
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className={className ? `svg-inline--fa ${className}` : "svg-inline--fa"}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${largura} ${altura}`}
    >
      <path fill="currentColor" d={caminho} />
    </svg>
  );
};

export default Icone;
